import CryptoJS from 'crypto-js';
import MasterService from './../../../../../masterdata/services/masterdata.service';
import ClientService from './../../../../../clientmanagement/services/clientmanagement.service';
import Loader from '../../../../../shared/components/loader'

export default {
  name: 'Annexure',
  props:['contractId', 'callingFromClientContract'],
  components: {
    Loader,
  },
  data: function() {
    return {
      isLoading: false,
      contractedService: '',
      annexurename: '',
      annexurDescription: '',
      AnnexureFilePath: '',
      annexureinput: '',
      userName: '',
      fileExtension:'',
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
  },
  methods: {
    showCreateAnnexure() {
      this.$emit("goBackToParent")
    },
    async onFileChangedForAnnexure(event){
      let uploadAnnexureFile = event.target.files[0];
      if(uploadAnnexureFile.size > 20971520){
        return this.$alert(`Please upload document less than 20MB.`,this.annexurename,"error");
      }
      if ( /\.(jpe?g|png|pdf|xls|xlsx|ods|doc|docx)$/i.test(uploadAnnexureFile.name) ){
        this.isLoading = true;
        this.fileExtension = uploadAnnexureFile.name.split('.').pop().toLowerCase();
        let formData = new FormData();
        /*Add the form data we need to submit*/
        formData.append("file", uploadAnnexureFile);
        formData.append("annexure", true);
        formData.append("companyShortName", this.companyShortName);
        formData.append("fileName", uploadAnnexureFile.name);
        let result = await MasterService.uploadDocment(formData)
        this.isLoading = false;
        if (result.data.errorCode == 0) {
          this.$alert("Document Upload successfully.",this.annexurename,"success");
          this.AnnexureFilePath = result.data.data;
        } else {
          this.$alert("Please try again.",this.annexurename,"error");
          event.target.value = '';
          this.fileExtension = '';
        }
      }else {
        event.target.value = '';
        this.fileExtension = '';
        this.$alert("Please upload only allowed file format",this.annexurename,"error");
        return true;
      }
    },
    async createContractAnnexure(){
      try {
        var inputPayload = {};
        this.isLoading = true;
        inputPayload.annexurename = this.annexurename;
        inputPayload.annexuredscription = this.annexurDescription;
        inputPayload.annexureurl = this.AnnexureFilePath;
        let result;
        if (this.callingFromClientContract){
          inputPayload.clientcontractid = this.callingFromClientContract.id,
          inputPayload.createdby = this.userName
          result = await ClientService.saveClientContractAnnexure(inputPayload);
        }else{
          inputPayload.contractid = this.contractId;
          inputPayload.lastmodifiedby = this.userName;
          result = await MasterService.createContractAnnexure(inputPayload);
        }
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.annexurename, "success");
          this.$emit("goBackToParent")
        }else{
          this.$alert(result.data.message, this.annexurename, "error");
        }
      } catch(err){
        console.log(err);
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.createContractAnnexure(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/Template1/annexures/createAnnexure/createAnnexure.component.js